
import Vue from 'vue'
import { IHit } from '../store/state'

interface AppData {}

interface AppMethods {
    consolelog(): void
}

interface AppComputed {}

interface AppProps {
    item: IHit
}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'Puff',
    props: {
        item: {
            type: Object as () => IHit,
            required: true
        }
    },
	computed: {},
	methods: {
        consolelog() {
            console.log(this.$store.getters.hits)
        }
    },
	components: {}
})
